<template lang="pug">
  .card.card-back(@click="click")
    slot
</template>

<script>
export default {
  name: 'CardBack',
  methods: {
    click() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped lang="stylus">
  .card-back
    justify-content center
    text-align center
    color var(--card-color)
    background var(--block-background)
    @media (prefers-color-scheme: dark)
      color var(--card-color-dark)
      background var(--block-background-dark)
    &:before
      pointer-events none
      content " "
      position absolute
      top 10px
      right 10px
      bottom 10px
      left 10px
      border-radius 3px
      opacity .33
      border 4px double var(--card-border)
      @media (prefers-color-scheme: dark)
        border-color var(--card-border-dark)
</style>
